// extracted by mini-css-extract-plugin
module.exports = {"errorIndicator":"ErrorIndicator_errorIndicator__VkFtR","boom":"ErrorIndicator_boom__KlCcz"};